// extracted by mini-css-extract-plugin
export default {"footerText":"Footer_footerText__YMwUn","footer":"Footer_footer__a6ebY"};